import { vehicleReg as vehicleRegex } from '@by-miles/regex'
import { useEffect, useState } from 'react'

import { quoteId } from '../../../../../cache'
import { useChangeVehicle } from '../../../../../hooks/useChangVehicle'
import { useCreateQuote } from '../../../../../hooks/useCreateQuote'
import { useQuote } from '../../../../../hooks/useQuote'
import { usePreQuoteContext } from '../../../../../pages/PageValidator'
import { CarDetails } from '../../CarDetails'
import { EnterRegistration } from '..'

interface EnterRegistrationContainerProps {
  showRegInput: boolean
  setShowRegInput: (value: boolean) => void
}

export const EnterRegistrationContainer = ({ showRegInput, setShowRegInput }: EnterRegistrationContainerProps) => {
  const { createQuote, data: createQuoteData, error: createQuoteError, loading: createQuoteLoading } = useCreateQuote()
  const { setShowErrorBanner } = usePreQuoteContext()
  const {
    changeVehicle,
    data: changeVehicleData,
    error: changeVehicleError,
    loading: changeVehicleLoading,
  } = useChangeVehicle()
  const quote = useQuote()

  const queryString = window.location.search
  const urlParams: any = new URLSearchParams(queryString)
  const { sid = '', qqid = '', reg: qqReg = '' } = Object.fromEntries(urlParams)

  const [registrationNumber, setRegistrationNumber] = useState<string>(qqReg)
  const [regError, setRegError] = useState<string>('')

  const id = quoteId()

  useEffect(() => {
    if (createQuoteData) {
      setShowRegInput(false)
    }
  }, [createQuoteData])

  useEffect(() => {
    if (registrationNumber && !id) createQuote({ variables: { reg: registrationNumber, qqid, sid } })
  }, [])

  useEffect(() => {
    const replaceCurrentQuote =
      (quote?.details.qqid && qqid && qqid !== quote?.details.qqid) || (id && !quote?.details.qqid && qqid)
    if (replaceCurrentQuote) {
      setShowRegInput(true)
      createQuote({ variables: { reg: registrationNumber, qqid, sid } })
    }
  }, [qqid])

  useEffect(() => {
    if (!createQuoteError && !changeVehicleError) return
    setRegError("Sorry, we can't find that car. Please check your registration plate and try again.")
  }, [createQuoteError, changeVehicleError])

  const handleSetReg = (value: string) => {
    setRegError(value ? '' : "Please type in a car's registration number to search for it")
    setRegistrationNumber(value)
  }

  const handleFindReg = async () => {
    if (!registrationNumber || !registrationNumber.match(vehicleRegex)) {
      setRegError("Sorry, this doesn't look like a reg number.")
      return
    }
    id
      ? changeVehicle({ variables: { id, reg: registrationNumber } })
      : createQuote({ variables: { reg: registrationNumber, qqid, sid } })
  }

  const handleResetRegistration = () => {
    setRegistrationNumber('')
    setShowErrorBanner(false)
    setShowRegInput(true)
  }

  useEffect(() => {
    if (changeVehicleData || createQuoteData) setShowRegInput(false)
  }, [createQuoteData, changeVehicleData])

  return (
    <>
      {showRegInput ? (
        <EnterRegistration
          registrationNumber={registrationNumber}
          regError={regError}
          handleFindReg={handleFindReg}
          handleSetReg={handleSetReg}
          createQuoteLoading={createQuoteLoading}
          changeVehicleLoading={changeVehicleLoading}
        />
      ) : (
        <CarDetails onClick={handleResetRegistration} />
      )}
    </>
  )
}
